import '../less/components.less';
import '../js/more-less';
import './phone-control'

$(document).ready(function () {

    $(".js-range-slider.price_range").ionRangeSlider({
        type: "double",
        min: 989,
        max: 3189,
        from: 989,
        to: 3189,
        step: 100,
        prefix: "£"
    });
    $(".calendar-appointment").datepicker({
        dateFormat: "DD, dd-M-y",
        minDate: 0,
        /**La funcion onSelect es solo para el demo de fractal */
        onSelect: (data) => {
            const data_calendar = document.querySelector(".date-calendar")
            data_calendar.textContent = data
        },
    });
});